module.exports = __webpack_public_path__ + "static/media/ql-icon-pay.53eafc6e.svg";